<template>
  <div class="comment_container" style="background: none">
    <div class="header">
      <a-avatar
        :style="{
          color: ' #ffffff !important',
          backgroundColor: data.user_circle[0].url ? '' : getAvatarColor(0),
          fontSize: '16px',
          fontWeight: '700',
        }"
        :src="data.user_circle[0].url"
        :size="40"
        class="text-capitalize cp"
      >
        {{ data.user_circle[0].role === "doctor" || data.user_circle[0].role === "physician" ? data.user_circle[0].first_name[0] : data.user_circle[0].display_name[0] }}
      </a-avatar>
      <div class="pl-2">
        <div class="d-flex">
          <p class="name" style="flex: 1">
            {{
              data.user_circle[0].role === "doctor" || data.user_circle[0].role === "physician"
                ? data.user_circle[0].first_name + " " + data.user_circle[0].last_name
                : data.user_circle[0].display_name
            }}
          </p>
          <span v-if="data.reply_to_reply" class="name-icon">></span>
          <p v-if="data.reply_to_reply" class="name">
            {{ parent }}
          </p>
        </div>
        <div class="d-flex align-items-center" style="gap: 5px">
          <div class="py-1" v-if="data.user_circle[0].role === 'hospital_administrator'">
            <span class="post-physician py-1 px-2 orange-text orange-bg font12">
              <font-awesome-icon size="1x" :icon="['far', 'hospital-alt']" class="mr-1" />
              Hospital
            </span>
            <span class="font12 pl-1">
              {{ data.user_circle[0].speciality }}
            </span>
          </div>
          <div class="py-1" v-if="data.user_circle[0].role === 'business_administrator'">
            <span class="post-physician py-1 px-2 orange-text orange-bg font12">
              <font-awesome-icon size="1x" :icon="['far', 'store']" class="mr-1" />
              Business
            </span>
          </div>
          <div class="" v-if="data.user_circle[0].role === 'clinic_administrator'">
            <span class="post-physician py-1 px-2 orange-text orange-bg font12">
              <font-awesome-icon size="1x" :icon="['far', 'hospital']" class="mr-1" />
              Clinic
            </span>
          </div>
          <div class="p-0" v-if="data.user_circle[0].role === 'doctor' || data.user_circle[0].role === 'physician'">
            <span class="post-physician py-1 px-2 orange-bg orange-text font12">
              <font-awesome-icon size="1x" :icon="['far', 'user-md']" class="mr-1" />
              Physician
            </span>
            <span class="font12 pl-1">
              {{ data.user_circle[0].speciality }}
            </span>
          </div>
          <div class="p-0" v-if="data.user_circle[0].role === 'hcp' || data.user_circle[0].role === 'ohcp'">
            <span class="post-physician py-1 px-2 orange-bg orange-text font12">
              <font-awesome-icon size="1x" :icon="['far', 'user-nurse']" class="mr-1" />
              Advanced Practice Provider
            </span>
            <span class="font12 pl-1">
              {{ data.user_circle[0].speciality }}
            </span>
          </div>
          <div class="post-physician p-1 pl-2 pr-2 mt-2 mb-2" v-if="data.user_circle[0].role === 'nfp'">Non For Profit</div>
          <div class="post-physician py-1 px-2 orange-bg orange-text font12" v-if="data.user_circle[0].role === 'advocate'">
            <div v-if="data.user_circle[0].organization">Supporting {{ data.user_circle[0].organization }}</div>
            <div v-else class="orange-text font12">
              <font-awesome-icon size="1x" :icon="['far', 'user-md']" class="mr-1" />
              Advocate for
              {{ currentCircle.condition_type.slice(0, 20) }}
              {{ currentCircle.condition_type.length > 20 ? "..." : "" }}
            </div>
          </div>
          <p class="posted">
            {{ formatPostTime(data.created_at) }}
          </p>
        </div>
      </div>
    </div>
    <p class="card_description pl-5 pt-3">
      {{ data.comment_text }}
    </p>
    <div v-for="image in data.comment_attach_url" :key="image.name">
      <img :src="image.resized_images ? image.resized_images.dov640x320 : image.url" :alt="image.name" width="50%" class="comment-image" />
    </div>
  </div>
</template>

<script>
export default {
  name: "CommentsCard",
  props: {
    data: Object,
    parent: String,
  },
  created() {
    this.data.user_circle = this.data.user_circle.length ? this.data.user_circle : this.data.user
  },
  methods: {
    formatPostTime(value) {
      const d = new Date(value)
      const now = new Date()
      const seconds = Math.round(Math.abs((now.getTime() - d.getTime()) / 1000))
      const minutes = Math.round(Math.abs(seconds / 60))
      const hours = Math.round(Math.abs(minutes / 60))
      const days = Math.round(Math.abs(hours / 24))
      const months = Math.round(Math.abs(days / 30.416))
      const years = Math.round(Math.abs(days / 365))
      if (Number.isNaN(seconds)) {
        return ""
      } else if (seconds <= 45) {
        return "a few seconds ago"
      } else if (seconds <= 90) {
        return "a minute ago"
      } else if (minutes <= 45) {
        return minutes + " minutes ago"
      } else if (minutes <= 90) {
        return "an hour ago"
      } else if (hours <= 22) {
        return hours + " hours ago"
      } else if (hours <= 36) {
        return "a day ago"
      } else if (days <= 25) {
        return days + " days ago"
      } else if (days <= 45) {
        return "a month ago"
      } else if (days <= 345) {
        return months + " months ago"
      } else if (days <= 545) {
        return "a year ago"
      } else {
        // (days > 545)
        return years + " years ago"
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.comment_container {
  padding: 16px;
  margin: 16px;
  background: rgba(255, 215, 204, 0.3);
  border-radius: 4px;
  .header {
    display: flex;
    align-items: center;
    .name {
      font-weight: 700;
      font-size: 16px;
      line-height: 24px;
      color: #0f1734;
      margin-bottom: 4px;
    }
  }
}
.comment-image {
  margin: 10px;
  margin-left: 52px;
  width: 100%;
  max-width: 200px;
  max-height: 150px;
  height: 100%;
  object-fit: contain;
}
.name-icon {
  margin: 0px 8px;
  color: #0f1734;
  font-weight: 700;
  font-size: 18px;
  line-height: 24px;
}
</style>



// WEBPACK FOOTER //
// src/components/home/aboutCircle/CommentsCard.vue